exports.IDS = {
  // IMG_URL: "http://127.0.0.1:2508",
  // IMG_URL: "http://192.168.16.53:2508",
  IMG_URL: "https://goalocalnode.profcymadev.com:2508",

  PAGE: 1,
  PERPAGE: 10,
  TOTALPAGES: 1,
  TOTAL: 1,
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  BLOCK: "BLOCKED",
  UNBLOCK: "UNBLOCKED",
  SLICESTATUS: {
    Idle: "idle",
    Loading: "loading",
    Succeeded: "succeeded",
    Failed: "failed",
  },
};
